<template lang="pug">
  div
    .guide-modal(:class="{ open: showGuide }")
      a.guide-modal-close(@click="close")
        | 閉じる
      .guide-modal-title
        | 活用ガイド
      hooper(ref="carousel")
        slide
          .image-area(v-if="identifier () === 'kobot'")
            img(src="/static/images/guide/kobot/menu1.png")
          .image-area(v-else-if="identifier () === 'mynavi'")
            img(src="/static/images/guide/mynavi/menu1.png")
          .image-area(v-else)
            img(src="/static/images/guide/menu1.png")
        slide
          .image-area(v-if="identifier () === 'kobot'")
            img(src="/static/images/guide/kobot/menu2.png")
          .image-area(v-else-if="identifier () === 'mynavi'")
            img(src="/static/images/guide/mynavi/menu2.png")
          .image-area(v-else)
            img(src="/static/images/guide/menu2.png")
        hooper-pagination(slot="hooper-addons")
        hooper-navigation(slot="hooper-addons")
    .modal-cover
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper'
  import 'hooper/dist/hooper.css'

  export default {
    components: { Hooper, Slide, HooperPagination, HooperNavigation },
    computed: {
      ...mapGetters({
        showGuide: 'guide/showGuide',
      }),
    },
    watch: {
      showGuide () {
        this.$refs.carousel.restart()
      },
    },
    methods: {
      close () {
        this.$store.commit('guide/hideModal')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/GuideModal.vue